<div
    class="main__container"
    fxLayout="row"
    fxLayoutAlign="center center"
    fxLayoutGap="1rem"
>
    <div class="left-side__column" fxFlex="40" fxLayoutAlign="end center">
        <img
            class="grad-hat"
            src="../../../../assets/grad-hat.png"
            width="85%"
            height="85%"
        />
    </div>
    <div class="right-side__column" fxFlex="60">
        <h1 class="main__message">
            {{ "Looks like something went wrong!" | translate }}
        </h1>
        <h2>{{ "Error" | translate }}:</h2>
        <p>{{ errorMessage }}</p>
        <p
            style="
                padding: 10px 20px;
                border-radius: 1000px;
                font-weight: 500;
                background-color: lightgray;
                width: max-content;
            "
        >
            {{ msg }}
        </p>
    </div>
</div>
